import { i18n, i18nExists } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';
import { usageLogTypeLabel } from 'src/modules/usageLog/usageLogFormatters';

const userLabel = (value) => {
  if (!value) {
    return null;
  }

  if (!value.fullName) {
    return value.email || null;
  }

  return `${value.fullName} <${value.email}>`;
};

const deviceLabel = (value) => {
  if (!value) {
    return null;
  }

  const key = `entities.usageLog.enumerators.device.${value}`;
  return i18nExists(key) ? i18n(key) : String(value);
};

const relationField = (field) => (value) =>
  value && value[field] ? value[field] : null;

// Built as a function (not a module-level array) so the i18n labels are
// resolved when the export actually runs, after the dictionary has loaded.
// Resolving them at module-load time yields raw keys, because the store —
// and therefore this module — is imported (via authAxios) before
// `i18nInit()` finishes during bootstrap.
const usageLogListExporterFields = () => [
  {
    name: 'id',
    label: i18n('entities.usageLog.fields.id'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.usageLog.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'createdBy',
    label: i18n('entities.usageLog.fields.createdBy'),
    render: userLabel,
  },
  {
    name: 'type',
    label: i18n('entities.usageLog.fields.type'),
    render: (value) => usageLogTypeLabel(value),
  },
  {
    name: 'device',
    label: i18n('entities.usageLog.fields.device'),
    render: deviceLabel,
  },
  {
    name: 'affirmationProgram',
    label: i18n('entities.usageLog.fields.affirmationProgram'),
    render: relationField('title'),
  },
  {
    name: 'affirmation',
    label: i18n('entities.usageLog.fields.affirmation'),
    render: relationField('text'),
  },
  {
    name: 'soundTitle',
    label: i18n('entities.usageLog.fields.soundTitle'),
    render: relationField('title'),
  },
  {
    name: 'sound',
    label: i18n('entities.usageLog.fields.sound'),
    render: relationField('name'),
  },
  {
    name: 'meditation',
    label: i18n('entities.usageLog.fields.meditation'),
    render: relationField('title'),
  },
  {
    name: 'enterpriseAlexaSkill',
    label: i18n('entities.usageLog.fields.enterpriseAlexaSkill'),
    render: relationField('partner'),
  },
];

export default usageLogListExporterFields;
